export const config = {
  routingHost: "https://tj-dev.cf-bbox.com",
  apiRoute:
    "https://northamerica-northeast1-tj-dev-11d7f.cloudfunctions.net/backend",
  bannerApiRoutes: {
    jeunes: "/jeunesBannerInfo",
    parents: "/parentsBannerInfo",
  },
  appId: "PKUB58O14L",
  apiKey: "ece75c106f1be34e6d7db156f2e4c2d1",
  indexName: "jeunes_search",
  squidex: {
    clientId: "tel-jeunes:webcomponents",
    clientSecret: "79ofxdcdqzafilkwxe5hgdwpm5mzicx7sctbwq2aj78x", 
  },
  routing: {
    en: {
      search: "/search",
      searchResults: "/en/search",
      youthsSearchResults: "/en/youths/search",
      parentsSearchResults: "/en/parents/search",
      newsletter: "/newsletter",
      contactForm: "/contact-form",
      trainingForm: "/training-form",
      servicesForm: "/services-form",
      kitForm: "/kit-form",
      popupForm: "/popup-form",
      contactPopupForm: "/contact-popup-form",
      trainingPopupForm: "/fr-training-popup-form",
      servicesPopupForm: "/services-popup-form",
      promotionalMaterialForm: "/promotional-material-form",
      podcasts: "/podcasts",
      cookiesPopup: "/cookies-popup",
    },
    fr: {
      search: "/recherche",
      searchResults: "/fr/recherche",
      youthsSearchResults: "/fr/jeunes/recherche",
      parentsSearchResults: "/fr/parents/search",
      newsletter: "/fr-newsletter",
      contactForm: "/fr-contact-form",
      trainingForm: "/fr-training-form",
      servicesForm: "/fr-services-form",
      kitForm: "/fr-kit-form",
      popupForm: "/fr-popup-form",
      contactPopupForm: "/fr-contact-popup-form",
      trainingPopupForm: "/fr-training-popup-form",
      servicesPopupForm: "/fr-services-popup-form",
      promotionalMaterialForm: "/fr-promotional-material-form",
      podcasts: "/fr-podcasts",
      cookiesPopup: "/fr-cookies-popup",
    },
  },
};
